<template>
  <div class="body">
    <!-- 使用 TopNav 组件 -->
    <TopNav />

    <div class="page">
      <div class="img1"><img src="@/assets/代表工程/深圳地铁13号线.jpeg" alt="">
        <div class="img1title">深圳地铁13号线</div></div>
      <div class="mode">
        <div class="mode1">
          <div class="modetitle">
            <div class="gang"></div>
            <span>企业证书</span>
            <div class="gang"></div>
          </div>
          <div class="dv">
            <div class="modepage">
              <div class="contact" @click="$router.push()">
                <div class="conimg"><img src="@/assets/公司荣誉/WechatIMG25.jpeg" alt=""></div>
              </div>
              <div class="contact" @click="$router.push()">
                <div class="conimg"><img src="@/assets/公司荣誉/WechatIMG24.jpeg" alt=""></div>
              </div>
              <div class="contact" @click="$router.push()">
                <div class="conimg"><img src="@/assets/公司荣誉/WechatIMG26.jpeg" alt=""></div>
              </div>
              <div class="contact" @click="$router.push()">
                <div class="conimg"><img src="@/assets/公司荣誉/WechatIMG35.jpeg" alt=""></div>
              </div>
              <div class="contact" @click="$router.push()">
                <div class="conimg"><img src="@/assets/公司荣誉/WechatIMG36.jpeg" alt=""></div>
              </div>
              <div class="contact" @click="$router.push()">
                <div class="conimg"><img src="@/assets/公司荣誉/WechatIMG37.jpeg" alt=""></div>
              </div>
              <div class="contact" @click="$router.push()">
                <div class="conimg"><img src="@/assets/公司荣誉/WechatIMG38.jpeg" alt=""></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div>
        <FootIndex></FootIndex>
      </div>
    </div>
  </div>
</template>

<script>
import TopNav from '@/components/TopNav.vue' // 引入 TopNav 组件
import FootIndex from '@/components/FootIndex.vue'

export default {
  name: 'HonourIndex',
  components: {
    TopNav, // 注册 TopNav 组件
    FootIndex
  }
}
</script>

<style lang="less" scoped>
.body {
  display: grid;
  grid-template-rows: 66px auto; /* 第一行是 nav 的高度，第二行是剩余空间 */
  height: 100vh;
}

.page{
  padding-top: 100px;
}

.img1 {
  width: 100%;
  height: 400px;
  min-width: 1000px;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
}

.img1 img{
  width: 100%;
  min-width: 1200px;
  object-fit: cover; /* 图片填充容器，保持比例 */
  object-position: center; /* 图片居中 */
  position: relative;
}

.img1title{
  position: absolute;
  bottom: 40px; /* 放置在底部 */
  left: 50%; /* 水平居中 */
  transform: translateX(-50%); /* 水平居中 */
  background-color: rgba(8, 105, 231, 0.558); /* 背景色 */
  color: white; /* 文字颜色 */
  padding: 4px 0px; /* 内边距 */
  border-radius: 5px; /* 圆角 */
  z-index: 1;
  width: 40%;
}

.modetitle {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 20px;
}

.modetitle span {
  font-size: 30px;
    padding-top: 0px;
    font-weight: bold;
    font-family: SimSun;
  color: #000;
  margin: 0 6px 0px 6px;
}

.gang {
  display: block;
  background: rgb(198, 198, 198);
  width: 1rem;
  height: 0.062rem;
  border-radius: inherit;
}

.modepage {
  width: 60%;
  display: grid;
  grid-template-columns: repeat(3, 1fr); /* 一行最多三列 */
  gap: 20px; /* 照片之间的间距 */
  padding: 20px;
}

.dv{
  display: flex;
  align-items: center;
  justify-content: center;
}

.contact {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%; /* 确保每个盒子宽度一致 */
  aspect-ratio: 1 / 1; /* 保持盒子为正方形 */
  border-radius: 10px; /* 圆角 */
  overflow: hidden; /* 隐藏超出部分 */
}

.conimg {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px; /* 添加内边距，避免图片紧贴边缘 */
}

.conimg img {
  width: 100%;
  height: 100%;
  object-fit: contain; /* 保持图片比例，完整显示图片 */
  object-position: center; /* 图片居中显示 */
}

/* 响应式布局：在小屏幕上调整为两列 */
@media (max-width: 768px) {
  .modepage {
    grid-template-columns: repeat(2, 1fr);
  }
}

/* 在更小的屏幕上调整为一列 */
@media (max-width: 480px) {
  .modepage {
    grid-template-columns: repeat(1, 1fr);
  }
}
</style>
